import Modal from '../../Modal';
import { Title, Footer, Container, DivIcon } from './styles';
import Button from '../../Button';
import Close from '../../../../assets/icons/Close';
import { ConfirmSubtask } from '../../../../assets/TaskModalIcons/ConfirmSubtask';

//? Finished Flow modal:
//isOpen -> Controlador se o modal está aberto ou não
//onClose -> Função executada ao cancelar/fechar/clicar fora do modal
//onConfirm -> Função executada ao confirmar no modal
//selector -> Local onde o modal sera renderizado(root -> Toda a tela)
//className -> nodrag = modal não pode ser movido
//flowName -> Nome renderizado na tela

const FinishedFlowModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
  flowName,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <ConfirmSubtask
          hover={true}
          style={{ marginTop: '1rem' }}
          height="4rem"
          className="confirm"
        />
        <Title>FLUXO CONCLUÍDO!</Title>
        <h3>Deseja voltar para o menu principal?</h3>
        <Footer>
          <Button
            outline
            content="Cancelar"
            width={'11.3125rem'}
            height={'2.625rem'}
            onClick={onClose}
          />
          <Button
            greenBase={true}
            content="Sim, voltar para o menu"
            width={'11.3125rem'}
            height={'2.625rem'}
            onClick={onConfirm}
          />
        </Footer>
        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default FinishedFlowModal;
